const mt=document.getElementById('mtrack');
if(mt) mt.innerHTML=mt.innerHTML+mt.innerHTML;
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in'); io.unobserve(e.target);}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const steps=[];
const tend=document.querySelector('.tend');
const rp=document.getElementById('railprogress');
function railTo(el){
  /* the line fills left to right: to the centre of whichever step has arrived */
  const rail=el.closest('.rail'); if(!rail) return;
  if(!rp) return;
  const rr=rail.getBoundingClientRect();
  const er=el.getBoundingClientRect();
  const w=Math.min(rr.width, Math.max(0, (er.left - rr.left) + er.width/2));
  rp.style.width=(el.classList.contains('tend') ? rr.width : w)+'px';
}
const tio=new IntersectionObserver(es=>es.forEach(e=>{
  if(e.isIntersecting){
    e.target.classList.add('in');
    railTo(e.target);
    if(e.target===steps[steps.length-1]) setTimeout(()=>{tend.classList.add('in'); railTo(tend);},350);
    tio.unobserve(e.target);
  }
}),{threshold:.55});
steps.forEach(s=>tio.observe(s));
const dbtns=[...document.querySelectorAll('.dbtn')];
const dpanels=[...document.querySelectorAll('.dpanel')];
const glayers=[...document.querySelectorAll('.dlayer')];
const dlegs=[...document.querySelectorAll('.dleg')];
function setDepth(d){
  dbtns.forEach(b=>{const on=b.dataset.d===d; b.classList.toggle('active',on); b.setAttribute('aria-selected',on);});
  dpanels.forEach(p=>p.classList.toggle('active',p.dataset.d===d));
  glayers.forEach(g=>g.classList.toggle('on', +(g.dataset.d||0) <= +d));
  dlegs.forEach((g,i)=>g.classList.toggle('on', i < +d));
}
dbtns.forEach(b=>b.addEventListener('click',()=>setDepth(b.dataset.d)));
setDepth('1');
const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
function pickOpt(el){[...el.parentElement.children].forEach(c=>c.classList.remove('sel')); el.classList.add('sel');}
// count-up numbers
const counts=[...document.querySelectorAll('[data-count]')];
const cio=new IntersectionObserver(es=>es.forEach(e=>{
  if(e.isIntersecting){runCount(e.target); cio.unobserve(e.target);}
}),{threshold:.6});
counts.forEach(el=>{if(RM){el.textContent=el.dataset.count;}else{el.textContent='0'; cio.observe(el);}});
function runCount(el){
  const to=+el.dataset.count, dur=1100, t0=performance.now();
  (function f(t){
    const p=Math.min(1,(t-t0)/dur);
    el.textContent=Math.round(to*(1-Math.pow(1-p,3)));
    if(p<1)requestAnimationFrame(f);
  })(t0);
}
// chat thread plays when seen
const chat=document.querySelector('#why .chatcard');
if(chat){
  const wio=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){chat.classList.add('play'); wio.disconnect();}
  }),{threshold:.45});
  wio.observe(chat);
}
// the cancelled board: rows flip one at a time, then hold
const fb=document.getElementById('failboard');
if(fb){
  const fio=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){
      [...fb.querySelectorAll('.fb-row:not(.fb-head)')].forEach((r,i)=>{
        setTimeout(()=>r.classList.add('flip'), RM?0:400+i*480);
      });
      fio.disconnect();
    }
  }),{threshold:.35});
  fio.observe(fb);
}

const mio=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('draw'); mio.unobserve(e.target);}}),{threshold:.6});
document.querySelectorAll('.metaline').forEach(el=>mio.observe(el));
// router: direct page swap. Works in sandboxed viewers where hash navigation is blocked.
const RMG=matchMedia('(prefers-reduced-motion: reduce)').matches;
/* the reading hairline runs on the same frame-sampled drive as the slides */
(function(){
  const bar=document.getElementById('readbar'); if(!bar) return;
  (function frame(){
    if(!document.hidden){
      const max=document.documentElement.scrollHeight-innerHeight;
      bar.style.transform='scaleX('+(max>0?Math.min(1,scrollY/max):0)+')';
    }
    requestAnimationFrame(frame);
  })();
})();
/* Shopify serves real URLs, so the prototype's page swapper is retired.
   `pages` is kept as a shim because a few effects ask whether the home page is showing. */
const pages={home:{classList:{contains:()=>document.body.classList.contains('t-index')}}};
document.querySelectorAll('[data-home-anchor]').forEach(a=>{
  a.addEventListener('click',e=>{
    const anchor=a.getAttribute('href')||'';
    if(!anchor.startsWith('#')) return;
    const el=document.querySelector(anchor);
    if(el){ e.preventDefault(); el.scrollIntoView({block:'start', behavior:RMG?'auto':'smooth'}); }
  });
});
// metalines outside .reveal wrappers draw on their own
// hero eases back as you scroll past it
const heroLeft=document.querySelector('.hero .grid > div:first-child');
if(heroLeft && !RM){
  addEventListener('scroll',()=>{
    if(!pages.home.classList.contains('active'))return;
    const y=Math.min(scrollY,520);
    heroLeft.style.transform=`translateY(${y*0.10}px)`;
    heroLeft.style.opacity=String(1-y/820);
  },{passive:true});
}

/* ===================== THE VAULT =====================
   Built to the assessment-funnel standard. */
/* ============ THE VAULT · CONFIG ============
   Catalogue and prices from OCTAFLOW_295_PRODUCT_SHOPIFY_IMPORT, 885 variants.
   All 295 products are priced at all three layers, so any product is routable.
   p:[layer1, layer2, layer3] matches the Shopify variant prices exactly.
   Axis two uses two guards: a depth ceiling by revenue, and a hard money ceiling
   by revenue, because a layer two ranges from $6,000 to $12,000. */
const CONFIG = {
  intro: {
    eyebrow: 'A five-minute consultation',
    h1: 'Tell us what is going wrong. We will tell you how to fix it.',
    lead: 'Five questions, the way you would explain it to someone over coffee. At the end you get the three things we would do about it, what each one costs, and where we would start.',
    pills: ['Free', 'No account needed', 'About five minutes'],
    cta: 'Start'
  },
  depths: [
    {key:'answer', name:'The answer',
     what:'We work out what to do and hand you the plan. Your team runs it.'},
    {key:'method', name:'The working method',
     what:'We build it, test it on your real work, and show your team how to run it.'},
    {key:'system', name:'The full system',
     what:'We design and build the whole thing across your tools and teams, then hand you the keys.'}
  ],
  catalogue: {
    t_gov:{name:"Rules for using AI", ref:'OF-F01', p:[2500,7500,35000],
      demo:"Who is allowed to use AI for what, written down, with a named person answerable for each decision."},
    t_risk:{name:"Deciding which AI uses are safe", ref:'OF-F08', p:[2500,7500,38000],
      demo:"One test you run before saying yes to any new AI use, so the answer is the same whoever asks."},
    t_agent:{name:"AI agents that behave", ref:'OF-F07', p:[3500,12000,50000],
      demo:"Agents with limits you set: what they can touch, what they must never do, and when a person takes over."},
    t_data:{name:"Getting your data straight", ref:'OF-G133', p:[3500,12000,50000],
      demo:"Who owns which numbers, what they mean, and how a wrong one gets fixed rather than argued about."},
    t_roi:{name:"Working out if the AI is worth it", ref:'OF-F02', p:[2000,6000,28000],
      demo:"What the AI tools are costing you, what they are giving back, and which ones to stop paying for."},
    f_price:{name:"Checking your prices and margins", ref:'OF-S23', p:[2000,6000,30000],
      demo:"What a job really costs you, what it is worth to the buyer, and what your price should be."},
    f_fcast:{name:"A forecast people believe", ref:'OF-F14', p:[3000,9000,40000],
      demo:"AI does the scenarios. Every assumption and override stays visible, so the number can be defended."},
    f_ctrl:{name:"Financial controls that hold", ref:'OF-F24', p:[2000,6500,32000],
      demo:"The approvals, limits and checks your close depends on, written down and actually followed."},
    f_close:{name:"Month end that stops eating the month", ref:'OF-G026', p:[3000,10000,45000],
      demo:"The close, taken apart and put back together so it finishes in days rather than weeks."},
    f_sys:{name:"Ready for a board or a funder", ref:'OF-C04', p:[3000,10000,45000],
      demo:"The numbers, the evidence behind them and the story they tell, in a state that survives questioning."},
    d_qa:{name:"What good work looks like", ref:'OF-G108', p:[3000,9000,40000],
      demo:"A written standard for the work and a check that catches a problem before the customer does."},
    d_inc:{name:"Stopping the same failure twice", ref:'OF-G110', p:[3000,10000,45000],
      demo:"Who does what when it breaks, and a route that fixes the cause instead of the symptom."},
    d_opt:{name:"Finding where the work jams", ref:'OF-S08', p:[3000,10000,45000],
      demo:"Where the work slows, doubles back or waits, and what to change first."},
    d_self:{name:"A business that learns as it works", ref:'OF-C08', p:[3500,12000,50000],
      demo:"The whole way you work, rebuilt so every fix sticks and the next month starts easier."},
    s_hand:{name:"Closing the gap between sale and delivery", ref:'OF-F31', p:[2000,6500,30000],
      demo:"Where the promise gets lost on the way to the people doing the work, and what it costs you."},
    s_play:{name:"A way of selling anyone can follow", ref:'OF-F29', p:[2000,6500,30000],
      demo:"How your best salesperson does it, written down so the next hire can do it too."},
    s_conv:{name:"Turning more talks into deals", ref:'OF-S14', p:[2500,9000,40000],
      demo:"Which deals are real, which are not, and what has to happen next on each one."},
    s_rev:{name:"Finding the money already in the business", ref:'OF-C13', p:[3500,12000,50000],
      demo:"The revenue you have already earned and lost track of, and the system that stops it happening again."},
    g_reg:{name:"A risk list that does something", ref:'OF-F16', p:[2000,6000,28000],
      demo:"Risks with an owner, a plan and a date, instead of a spreadsheet nobody opens."},
    g_pol:{name:"Policies people actually follow", ref:'OF-G167', p:[2500,7500,35000],
      demo:"Policies that reach the right people, get read, get signed off, and stay up to date."},
    g_doc:{name:"Paperwork that holds up", ref:'OF-F15', p:[3000,9000,40000],
      demo:"The compliance record written so it answers the question the first time it is asked."},
    g_audit:{name:"Ready for the audit before it starts", ref:'OF-S44', p:[3000,10000,45000],
      demo:"The evidence an auditor or a client will ask for, gathered and kept current in advance."},
    k_arch:{name:"Somewhere to look things up", ref:'OF-G080', p:[2500,8500,40000],
      demo:"One place where people, and any AI you use, can find the right answer and trust it."},
    k_sop:{name:"Writing down how the work is done", ref:'OF-G081', p:[2500,7500,35000],
      demo:"The steps your team follows, written once, so nobody has to explain them again."},
    k_exp:{name:"Keeping what your best people know", ref:'OF-G082', p:[2500,7500,35000],
      demo:"What lives in a few heads, captured and held by the company before those people leave."},
    k_person:{name:"When too much rests on one person", ref:'OF-G076', p:[2500,7500,35000],
      demo:"The jobs only one person can do, and a way to spread them before that person leaves."},
    c_adopt:{name:"Getting customers actually using it", ref:'OF-G094', p:[2500,7500,35000],
      demo:"Where new customers stall after signing, and what makes the habit stick."},
    c_recover:{name:"Putting it right when it goes wrong", ref:'OF-G103', p:[2500,7500,35000],
      demo:"What happens after a complaint, so the customer stays and the cause gets fixed."},
    c_churn:{name:"Keeping the customers you have", ref:'OF-G098', p:[3000,10000,45000],
      demo:"Spotting the ones about to leave, and the play that brings them back."},
    c_onboard:{name:"Getting new customers started properly", ref:'OF-G093', p:[2000,7500,32000],
      demo:"The first ninety days, run the same good way every time."},
  },
  categories: {
    tech:{name:'AI and data', diagnostic:'t_roi',
      triggers:{
        unchecked:{hero:'t_gov', supports:['t_risk','t_roi']},
        agents:{hero:'t_agent', supports:['t_risk','t_gov']},
        asked:{hero:'t_risk', supports:['t_gov','t_roi']},
        data:{hero:'t_data', supports:['t_gov','t_roi']},
        _default:{hero:'t_gov', supports:['t_risk','t_roi']}},
      qs:[["People are using AI and nobody signed it off",'unchecked'],
          ["We built something with AI and it keeps getting things wrong",'agents'],
          ["Someone is about to ask us how we use AI",'asked'],
          ["Our data is too messy to trust",'data']]},
    finance:{name:'Money and numbers', diagnostic:'f_price',
      triggers:{
        forecast:{hero:'f_fcast', supports:['f_ctrl','f_price']},
        margin:{hero:'f_price', supports:['f_ctrl','f_fcast']},
        close:{hero:'f_close', supports:['f_ctrl','f_price']},
        raise:{hero:'f_sys', supports:['f_fcast','f_ctrl']},
        _default:{hero:'f_fcast', supports:['f_price','f_ctrl']}},
      qs:[["Nobody believes the forecast",'forecast'],
          ["We are not sure we are making money on what we sell",'margin'],
          ["Month end takes over the whole month",'close'],
          ["A board or a funder is about to go through our numbers",'raise']]},
    delivery:{name:'How the work gets done', diagnostic:'d_qa',
      triggers:{
        repeat:{hero:'d_inc', supports:['d_qa','d_opt']},
        quality:{hero:'d_qa', supports:['d_inc','d_opt']},
        jams:{hero:'d_opt', supports:['d_qa','d_inc']},
        scale:{hero:'d_self', supports:['d_qa','d_opt']},
        _default:{hero:'d_qa', supports:['d_inc','d_opt']}},
      qs:[["The same problems keep coming back",'repeat'],
          ["The quality depends on who happens to do it",'quality'],
          ["Everything takes longer than it should",'jams'],
          ["How we work will not survive us getting bigger",'scale']]},
    sales:{name:'Selling and delivering', diagnostic:'s_hand',
      triggers:{
        leak:{hero:'s_hand', supports:['s_play','s_conv']},
        stall:{hero:'s_conv', supports:['s_hand','s_play']},
        people:{hero:'s_play', supports:['s_hand','s_conv']},
        revenue:{hero:'s_rev', supports:['s_conv','s_hand']},
        _default:{hero:'s_conv', supports:['s_hand','s_play']}},
      qs:[["What we sell and what we deliver are two different things",'leak'],
          ["Deals go quiet and we never know why",'stall'],
          ["Only one person here can really sell",'people'],
          ["We think we are losing money we have already earned",'revenue']]},
    customer:{name:'Keeping customers', diagnostic:'c_onboard',
      triggers:{
        start:{hero:'c_onboard', supports:['c_adopt','c_recover']},
        stall:{hero:'c_adopt', supports:['c_onboard','c_churn']},
        leave:{hero:'c_churn', supports:['c_adopt','c_recover']},
        complain:{hero:'c_recover', supports:['c_churn','c_onboard']},
        _default:{hero:'c_onboard', supports:['c_adopt','c_churn']}},
      qs:[["New customers take too long to get going",'start'],
          ["They sign up and then never really use it",'stall'],
          ["Customers leave and we find out too late",'leave'],
          ["Complaints get handled and then happen again",'complain']]},
    gov:{name:'Proving what you do', diagnostic:'g_reg',
      triggers:{
        audit:{hero:'g_audit', supports:['g_reg','g_doc']},
        risk:{hero:'g_reg', supports:['g_audit','g_pol']},
        policy:{hero:'g_pol', supports:['g_reg','g_doc']},
        paperwork:{hero:'g_doc', supports:['g_reg','g_audit']},
        _default:{hero:'g_reg', supports:['g_audit','g_pol']}},
      qs:[["An audit or a big client review is coming",'audit'],
          ["We write risks down and then nothing happens",'risk'],
          ["We have policies and nobody follows them",'policy'],
          ["Every request for evidence turns into a scramble",'paperwork']]},
    knowledge:{name:'What your company knows', diagnostic:'k_sop',
      triggers:{
        find:{hero:'k_arch', supports:['k_sop','k_exp']},
        people:{hero:'k_person', supports:['k_exp','k_sop']},
        leaver:{hero:'k_exp', supports:['k_arch','k_person']},
        sop:{hero:'k_sop', supports:['k_arch','k_exp']},
        _default:{hero:'k_sop', supports:['k_arch','k_exp']}},
      qs:[["Nobody can tell which version is the right one",'find'],
          ["Too much of it is in one or two people's heads",'people'],
          ["When someone leaves, we lose what they knew",'leaver'],
          ["We explain the same thing over and over",'sop']]}
  },
  symptoms:[
    ["We are using AI and it is not paying off",'tech'],
    ["We cannot trust our own numbers",'finance'],
    ["The same things keep going wrong",'delivery'],
    ["We sell one thing and deliver another",'sales'],
    ["Customers go quiet, then go elsewhere",'customer'],
    ["We cannot prove what we do",'gov'],
    ["Everything important is in someone's head",'knowledge']
  ],
  size:[
    ["Under $1M",'u1m'], ["$1M to $5M",'u5m'], ["$5M to $20M",'u20m'], ["Over $20M",'o20m']
  ],
  sizeCeiling:{u1m:0, u5m:1, u20m:1, o20m:2},
  sizeCap:    {u1m:1, u5m:1, u20m:2, o20m:2},
  moneyCap:   {u1m:8000, u5m:12000, u20m:50000, o20m:999999},
  intent:[
    ["Steady as we are",'steady'], ["Growing carefully",'careful'],
    ["Growing fast",'scaling'], ["Raising money, selling or restructuring",'raise']
  ],
  intentLift:['scaling','raise'],
  maturity:[
    ["Nothing. It is all in people's heads",'none'],
    ["Bits and pieces",'some'],
    ["It is written down and people follow it",'mature']
  ]
};

/* ---------- signature progress: the Octaflow octagon ---------- */
function octoVerts(cx,cy,r){const v=[];for(let i=0;i<8;i++){const a=(-90+22.5+i*45)*Math.PI/180;v.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}return v;}
function buildOcto(svg,r,withDot){
  const v=octoVerts(50,50,r);let s='';
  for(let i=0;i<8;i++){const a=v[i],b=v[(i+1)%8];s+=`<line x1="${a[0].toFixed(1)}" y1="${a[1].toFixed(1)}" x2="${b[0].toFixed(1)}" y2="${b[1].toFixed(1)}"/>`;}
  if(withDot)s+=`<circle class="dot" cx="50" cy="50" r="7" fill="var(--spark)"/>`;
  svg.innerHTML=s;
}
const octo=document.getElementById('octo');
if(octo) buildOcto(octo,38,true);
const VTOTAL=5;
function setProgress(answered){
  if(!octo) return;
  const lit=Math.round((answered/VTOTAL)*8);
  octo.querySelectorAll('line').forEach((l,i)=>l.classList.toggle('lit',i<lit));
  const dot=octo.querySelector('.dot');
  if(dot) dot.classList.toggle('on',answered>=VTOTAL);
  const sub=document.getElementById('vsub');
  if(sub) sub.textContent = answered>=VTOTAL ? 'Your results' : (answered===0 ? 'Five questions' : 'Question '+(answered+1)+' of '+VTOTAL);
}
setProgress(0);

/* ---------- state + panel ---------- */
const vstate={cat:null,trigger:null,size:null,intent:null,maturity:null,email:null};
const vstage=document.getElementById('stage');
let vstep=0;
function vpanel(html){
  if(!vstage) return null;
  const p=document.createElement('div');p.className='vpanel';p.innerHTML=html;
  vstage.innerHTML='';vstage.appendChild(p);requestAnimationFrame(()=>p.classList.add('show'));
  const f=p.querySelector('[autofocus]')||p.querySelector('.vopt,.vbtn,input');
  if(f&&vstep>0)setTimeout(()=>f.focus({preventScroll:true}),120);
  return p;
}
function voptsHTML(list){
  return '<div class="vopts" role="list">'+list.map((o,i)=>`<button class="vopt" role="listitem" data-i="${i}"><span class="vtick"></span><span>${o[0]}</span></button>`).join('')+'</div>';
}
function vfooter(back,hint){return `<div class="vfoot"><button class="vback" ${back?'':'disabled'}>Back</button><span class="vhint">${hint||''}</span></div>`;}
function vwire(p,list,cb){
  p.querySelectorAll('.vopt').forEach(btn=>{
    btn.onclick=()=>{p.querySelectorAll('.vopt').forEach(b=>b.classList.remove('sel'));btn.classList.add('sel');setTimeout(()=>cb(list[+btn.dataset.i]),RM?0:320);};
  });
}
function vback(p,cb){const b=p.querySelector('.vback');if(b&&!b.disabled)b.onclick=cb;}

/* ---------- the consultation ---------- */
function vIntro(){
  if(!vstage) return;   /* no intake on this template: stay asleep rather than throw */
  setProgress(0);
  const c=CONFIG.intro;
  const p=vpanel(`<p class="veyebrow">${c.eyebrow}</p>
    <h1>${c.h1}</h1>
    <p class="lead">${c.lead}</p>
    <div class="vpills">${c.pills.map(x=>`<span class="vpill">${x}</span>`).join('')}</div>
    <div><button class="vbtn pri" id="vbegin" style="width:auto;"><span class="ctaLabel">${c.cta}</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button></div>`);
  p.querySelector('#vbegin').onclick=()=>{vstep=1;vStep();};
}
function vStep(){
  if(!vstage) return;   /* the intake lives on its own template; elsewhere it stays asleep */
  if(vstep===1){
    setProgress(0);
    const p=vpanel(`<p class="veyebrow">Question 1 of 5 <span class="stepname">· The problem</span></p>
      <p class="q">What is the biggest problem right now?</p>${voptsHTML(CONFIG.symptoms)}${vfooter(true,'Pick the one that annoys you most')}`);
    vwire(p,CONFIG.symptoms,o=>{vstate.cat=o[1];vstate.trigger=null;vstep=2;vStep();});
    vback(p,()=>{vstep=0;vIntro();});
  } else if(vstep===2){
    setProgress(1);
    const qs=CONFIG.categories[vstate.cat].qs;
    const p=vpanel(`<p class="veyebrow">Question 2 of 5 <span class="stepname">· What it looks like</span></p>
      <p class="q">Which of these sounds most like you?</p>${voptsHTML(qs)}${vfooter(true,'')}`);
    vwire(p,qs,o=>{vstate.trigger=o[1];vstep=3;vStep();});
    vback(p,()=>{vstep=1;vStep();});
  } else if(vstep===3){
    setProgress(2);
    const p=vpanel(`<p class="veyebrow">Question 3 of 5 <span class="stepname">· Your size</span></p>
      <p class="q">What is your annual revenue?</p>${voptsHTML(CONFIG.size)}${vfooter(true,'This decides what we will and will not offer you')}`);
    vwire(p,CONFIG.size,o=>{vstate.size=o[1];vstep=4;vStep();});
    vback(p,()=>{vstep=2;vStep();});
  } else if(vstep===4){
    setProgress(3);
    const p=vpanel(`<p class="veyebrow">Question 4 of 5 <span class="stepname">· Where you are headed</span></p>
      <p class="q">What does the next year look like?</p>${voptsHTML(CONFIG.intent)}${vfooter(true,'')}`);
    vwire(p,CONFIG.intent,o=>{vstate.intent=o[1];vstep=5;vStep();});
    vback(p,()=>{vstep=3;vStep();});
  } else if(vstep===5){
    setProgress(4);
    const p=vpanel(`<p class="veyebrow">Question 5 of 5 <span class="stepname">· What you have already</span></p>
      <p class="q">How much of this is written down?</p>${voptsHTML(CONFIG.maturity)}${vfooter(true,'')}`);
    vwire(p,CONFIG.maturity,o=>{vstate.maturity=o[1];setProgress(5);vDiagnose();});
    vback(p,()=>{vstep=4;vStep();});
  }
}
/* ---------- working animation ---------- */
function vDiagnose(){
  const p=vpanel(`<div class="vdiag">
    <svg class="octo octo-big" id="octoBig" viewBox="0 0 100 100" aria-hidden="true"></svg>
    <div class="vdiagtext" id="vdt">Reading your answers</div>
    <div class="vdiagsub">Working out which of our products fit</div></div>`);
  const big=p.querySelector('#octoBig');buildOcto(big,40,false);
  big.querySelectorAll('line').forEach((l,i)=>setTimeout(()=>l.classList.add('pulse'),i*90));
  const msgs=['Reading your answers','Finding the ones that fit','Working out how far to go'];
  let i=0;const dt=p.querySelector('#vdt');
  const total=RM?400:2200;
  const iv=setInterval(()=>{i=(i+1)%msgs.length;dt.textContent=msgs[i];},RM?150:640);
  setTimeout(()=>{clearInterval(iv);vResults(vRecommend());},total);
}
/* ---------- the recommender ----------
   Axis one: the problem and what it looks like choose the category and the hero.
   Axis two: revenue sets a depth ceiling and a money ceiling. The next year can
   lift the depth by one, never past the cap for that revenue band, and never past
   the money ceiling. What is written down already decides whether the diagnosis
   leads. Always three routes. */
function depthFor(id, maxDepth, moneyCap){
  const p=CONFIG.catalogue[id].p;
  for(let d=maxDepth; d>0; d--){ if(p[d]<=moneyCap) return d; }
  return 0;
}
function vRecommend(){
  const L=CONFIG.categories[vstate.cat];
  const trig=L.triggers[vstate.trigger]||L.triggers._default;
  let ceil=CONFIG.sizeCeiling[vstate.size];
  const cap=CONFIG.sizeCap[vstate.size];
  const money=CONFIG.moneyCap[vstate.size];
  const lifted=CONFIG.intentLift.includes(vstate.intent) && ceil<cap;
  if(lifted)ceil=ceil+1;
  let items=[trig.hero,...trig.supports];
  const mature=vstate.maturity==='mature';
  const bare=vstate.maturity==='none';
  if(bare && items.includes(L.diagnostic) && items[0]!==L.diagnostic){
    items=[L.diagnostic,...items.filter(id=>id!==L.diagnostic)];
  }
  const heroId=items[0];
  const supportCeil=mature ? Math.min(ceil,1) : 0;
  const depths={}; let moneyBit=false;
  items.forEach((id,i)=>{
    const want=i===0?ceil:supportCeil;
    const got=depthFor(id,want,money);
    if(got<want)moneyBit=true;
    depths[id]=got;
  });
  return {cat:L.name, items, hero:heroId, depths, ceil, lifted, cap, money, moneyBit,
          ctaMode: depths[heroId]>=2 ? 'call' : 'self'};
}
function vWhy(rec){
  const sizeTxt={u1m:'under $1M',u5m:'between $1M and $5M',u20m:'between $5M and $20M',o20m:'over $20M'}[vstate.size];
  const maxShown=Math.max(...rec.items.map(id=>rec.depths[id]));
  const heroName=CONFIG.catalogue[rec.hero].name;
  let s=`You told us revenue is ${sizeTxt}, so the most we are putting in front of you is ${CONFIG.depths[maxShown].name.toLowerCase()}.`;
  if(rec.lifted && !rec.moneyBit) s+=' We moved it up a step because of where you are headed.';
  else if(rec.lifted && rec.moneyBit) s+=` Where you are headed would take you a step deeper, and building this one properly costs more than we would put in front of a business your size. So we have started you with the answer.`;
  else if(rec.moneyBit) s+=' One of these can go deeper. We have held that back until the first step proves it is worth it.';
  if(rec.cap<2) s+=' We are not showing you the full system, because at your size it would cost more than the problem.';
  if(vstate.maturity==='none') s+=' Since none of this is written down yet, we have put the groundwork first.';
  else if(vstate.maturity==='mature') s+=' Since it is already written down and followed, we have skipped the groundwork and gone to the part we build.';
  return s;
}
function vGate(p){
  const email=p.querySelector('#vemail').value.trim();
  const ok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const consent=p.querySelector('#vconsent').checked;
  if(!ok||!consent){p.querySelector('#verr').classList.add('show');return null;}
  p.querySelector('#verr').classList.remove('show');vstate.email=email;return email;
}
/* every quiz recommendation resolves to its live product page by SKU family */
const VURL={'OF-F01':'ai-governance-framework-design-of-f01','OF-F02':'ai-roi-measurement-and-business-case-of-f02','OF-F07':'ai-agent-design-and-deployment-of-f07','OF-F08':'ai-risk-assessment-for-operations-of-f08','OF-F14':'ai-assisted-forecasting-methodology-of-f14','OF-F15':'compliance-and-regulatory-documentation-of-f15','OF-F16':'risk-registers-of-f16','OF-F24':'financial-controls-and-policies-of-f24','OF-F29':'sales-playbook-design-of-f29','OF-F31':'sales-to-delivery-handover-documentation-of-f31','OF-S08':'operating-model-optimisation-system-of-s08','OF-S14':'sales-conversion-improvement-system-of-s14','OF-S23':'pricing-and-margin-check-of-s23','OF-S44':'audit-readiness-system-of-s44','OF-C04':'capital-readiness-and-evidence-system-of-c04','OF-C08':'self-improving-operating-model-of-c08','OF-C13':'revenue-recovery-operating-system-of-c13','OF-G026':'financial-close-acceleration-system-of-g026','OF-G076':'critical-person-dependency-system-of-g076','OF-G080':'company-knowledge-architecture-of-g080','OF-G081':'standard-operating-procedure-system-of-g081','OF-G082':'expert-knowledge-capture-system-of-g082','OF-G093':'customer-onboarding-operating-system-of-g093','OF-G094':'customer-adoption-system-of-g094','OF-G098':'churn-prevention-and-rescue-system-of-g098','OF-G103':'customer-service-recovery-system-of-g103','OF-G108':'knowledge-work-quality-assurance-system-of-g108','OF-G110':'incident-and-problem-management-system-of-g110','OF-G133':'company-data-governance-system-of-g133','OF-G167':'policy-lifecycle-management-system-of-g167'};
function vCard(id,rec,locked){
  const it=CONFIG.catalogue[id];
  const di=rec.depths[id];
  const d=CONFIG.depths[di];
  const isHero=id===rec.hero;
  const price='$'+it.p[di].toLocaleString('en-US');
  const inner = `${isHero?'<span class="vherotag">Start here</span>':''}
    <div class="vtop"><h3>${it.name}</h3><span class="vband">${d.name}</span></div>
    <p>${it.demo}</p>
    <div class="vfootline"><span class="vprice">${price}</span><span class="vref">${it.ref}</span></div>
    <p class="vwhat">${d.what}</p>`;
  if(!locked && VURL[it.ref]){
    return `<a class="vcard vlink${isHero?' hero':''}" href="/products/${VURL[it.ref]}">${inner}
      <span class="vgo">View and place your order<i aria-hidden="true"></i></span></a>`;
  }
  return `<div class="vcard${isHero?' hero':''}${locked?' locked':''}">${inner}</div>`;
}
function vResults(rec){
  const cards=rec.items.map(id=>vCard(id,rec,true)).join('');
  const p=vpanel(`
    <p class="vfloor">Your results · ${rec.cat}</p>
    <h1 style="font-size:28px; margin:6px 0 0;">We found three things we would do about it.</h1>
    <p class="vwhy">${vWhy(rec)}</p>
    <p class="vtotal">Start with the first one at <b>${'$'+CONFIG.catalogue[rec.hero].p[rec.depths[rec.hero]].toLocaleString('en-US')}</b>. All three together come to ${'$'+rec.items.reduce((t,id)=>t+CONFIG.catalogue[id].p[rec.depths[id]],0).toLocaleString('en-US')}, and you can stop after any of them.</p>
    <div class="vcards locked" id="vcards">${cards}
      <div class="vlockplate" id="vlockplate">
        <span class="vlockicon" aria-hidden="true"></span>
        <span>Locked until you tell us where to send it</span>
      </div>
    </div>
    <div class="vgate">
      <h3>Where should we send this?</h3>
      <p>Put your email in and we will show you all three now and send them over. ${rec.ctaMode==='call'?'At your size it is worth a call first, so we can ask a few things back.':''}</p>
      <input class="field" id="vemail" type="email" inputmode="email" placeholder="you@company.com" autocomplete="email" autofocus>
      <div class="verr" id="verr">Put in a real email and tick the box to carry on.</div>
      <label class="vconsent"><input type="checkbox" id="vconsent"><span>Send me my results and the odd note. I can stop them any time.</span></label>
      ${rec.ctaMode==='call'
        ? `<button class="vbtn pri" id="vbook"><span class="ctaLabel">Book a call and unlock</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button><div class="vor"><span>or</span></div><button class="vbtn line" id="vsend"><span class="ctaLabel">Email me my results</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button>`
        : `<button class="vbtn pri" id="vsend"><span class="ctaLabel">Email me my results</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button><div class="vor"><span>or</span></div><button class="vbtn line" id="vbook"><span class="ctaLabel">Book a call instead</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button>`}
    </div>`);
  setProgress(5);
  p.querySelector('#vsend').onclick=()=>{
    const email=vGate(p);if(!email)return;
    /* SELF-SERVE HOOK: POST { email, ...vstate, items:rec.items, depths:rec.depths } to the
       email platform and trigger the results flow. Build the delivered content server-side. */
    vUnlock(p,()=>vPreparing(email,rec));
  };
  p.querySelector('#vbook').onclick=()=>{
    const email=vGate(p);if(!email)return;
    /* REQUEST-A-CALL HOOK: POST { email, ...vstate, items:rec.items, depths:rec.depths,
       intent:'call' } to the team lead endpoint AND subscribe the email. */
    vUnlock(p,()=>vCall(email,rec));
  };
}
function vUnlock(p,then){
  const wrap=p.querySelector('#vcards');
  const plate=p.querySelector('#vlockplate');
  plate.classList.add('off');
  wrap.classList.remove('locked');
  wrap.querySelectorAll('.vcard').forEach((c,i)=>setTimeout(()=>c.classList.remove('locked'),RM?0:i*140));
  setTimeout(then,RM?200:900);
}
function vPreparing(email,rec){
  const p=vpanel(`<div class="vdiag">
    <svg class="octo octo-big" id="octoBig2" viewBox="0 0 100 100" aria-hidden="true"></svg>
    <div class="vdiagtext" id="vdt2">Writing it up</div>
    <div class="vdiagsub">A few seconds</div></div>`);
  const big=p.querySelector('#octoBig2');buildOcto(big,40,false);
  big.querySelectorAll('line').forEach((l,i)=>setTimeout(()=>l.classList.add('pulse'),i*90));
  const msgs=['Writing it up','Explaining each one','Sending it over'];
  let i=0;const dt=p.querySelector('#vdt2');
  const total=RM?400:1900;
  const iv=setInterval(()=>{i=(i+1)%msgs.length;dt.textContent=msgs[i];},RM?150:620);
  setTimeout(()=>{clearInterval(iv);vSent(email,rec);},total);
}
function vSent(email,rec){
  const cards=rec.items.map(id=>vCard(id,rec,false)).join('');
  const p=vpanel(`
    <div class="vbanner"><span class="vcheck small"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#FF7F6B" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      <div><b>Sent to ${email}.</b> It should land in a few minutes.</div></div>
    <p class="vfloor" style="margin-top:20px;">Your results · ${rec.cat}</p>
    <h1 style="font-size:26px; margin:6px 0 16px;">Here they are.</h1>
    <div class="vcards">${cards}</div>
    <p class="vhint">Each one names what we would do, what you get to keep, and what it costs. Reply to the email and a person will answer.</p>
    <button class="vrestart" id="vagain">Start again</button>`);
  setProgress(5);p.querySelector('#vagain').onclick=vReset;
}
function vCall(email,rec){
  const cards=rec.items.map(id=>vCard(id,rec,false)).join('');
  const p=vpanel(`
    <div class="vbanner"><span class="vcheck small"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="16" rx="1" stroke="#FF7F6B" stroke-width="2.5"/><path d="M3 10h18M8 3v4M16 3v4" stroke="#FF7F6B" stroke-width="2.5" stroke-linecap="round"/></svg></span>
      <div><b>We will be in touch at ${email}</b> to find a time. We have your answers, so the call starts with your situation.</div></div>
    <p class="vfloor" style="margin-top:20px;">Your results · ${rec.cat}</p>
    <h1 style="font-size:26px; margin:6px 0 16px;">Here they are.</h1>
    <div class="vcards">${cards}</div>
    <button class="vrestart" id="vagain">Start again</button>`);
  setProgress(5);p.querySelector('#vagain').onclick=vReset;
}
function vReset(){Object.keys(vstate).forEach(k=>vstate[k]=null);vstep=0;vIntro();}
vIntro();


/* ---------- the eight-stage cycle drawn on the octagon ---------- */
(function(){
  const STAGES=['See','Define','Encode','Act','Test','Correct','Retain','Revisit'];
  const svg=document.getElementById('cycleocto');
  if(!svg)return;
  const L=document.getElementById('cyclelines'), T=document.getElementById('cyclelabels');
  const cx=210, cy=210, r=126, lr=170;
  function vert(i){const a=(-90+22.5+i*45)*Math.PI/180; return [cx+r*Math.cos(a), cy+r*Math.sin(a)];}
  let lines='', labels='';
  for(let i=0;i<8;i++){
    const a=vert(i), b=vert((i+1)%8);
    lines+=`<line data-i="${i}" x1="${a[0].toFixed(1)}" y1="${a[1].toFixed(1)}" x2="${b[0].toFixed(1)}" y2="${b[1].toFixed(1)}"/>`;
    const mid=[(a[0]+b[0])/2,(a[1]+b[1])/2];
    const ang=Math.atan2(mid[1]-cy, mid[0]-cx);
    const lx=cx+lr*Math.cos(ang), ly=cy+lr*Math.sin(ang);
    let anchor='middle';
    if(lx>cx+30)anchor='start'; else if(lx<cx-30)anchor='end';
    labels+=`<text data-i="${i}" x="${lx.toFixed(1)}" y="${(ly+4).toFixed(1)}" text-anchor="${anchor}">${STAGES[i]}</text>`;
  }
  L.innerHTML=lines; T.innerHTML=labels;
  const core=svg.querySelector('.cyclecore');
  const ls=[...L.querySelectorAll('line')], ts=[...T.querySelectorAll('text')];
  /* the scroll drive calls this: p in [0,1] draws floor(p*8)+ edges and lands the core near the end */
  window.cycleSet=function(p){
    const lit=Math.min(8, Math.floor(p*8.6));
    ls.forEach((l,i)=>l.classList.toggle('lit', i<lit));
    ts.forEach((t,i)=>t.classList.toggle('lit', i<lit));
    core.classList.toggle('on', p>0.92);
  };
  window.cycleSet(0);
})();

// hero record cycles through representative engagements
(function(){
  const rec=document.getElementById('herorec'); if(!rec) return;
  if(!rec||RM)return;
  const title=rec.querySelector('#hrTitle'), foot=rec.querySelector('#hrFoot');
  const avs=[...rec.querySelectorAll('.arow .av')];
  const first={title:title.textContent, rows:avs.map(a=>a.innerHTML), foot:foot.textContent};
  const records=[first,
    {title:'Octaflow · outcome record',
     rows:['month-end close · 9 days → 3','extract → reconcile → sign-off','on your real cases · standard held','your team · checklist kept'],
     foot:'Outcome matched'},
    {title:'Octaflow · outcome record',
     rows:['every AI use approved, evidenced','register → rules → audit trail','decision rights stay human','your team · audit trail kept'],
     foot:'Outcome matched'}];
  let i=0;
  setInterval(()=>{
    if(!pages.home.classList.contains('active')||document.hidden)return;
    i=(i+1)%records.length;
    rec.classList.add('fading');
    setTimeout(()=>{
      const r=records[i];
      title.textContent=r.title; foot.textContent=r.foot;
      avs.forEach((a,k)=>a.innerHTML=r.rows[k]);
      rec.classList.remove('fading');
    },320);
  },7000);
})();


/* the slide fits the frame: measure whatever chrome sits above it */
(function(){
  function chrome(){
    const nav=document.querySelector('nav.site'), bar=document.querySelector('.draftbar');
    let px=0;
    if(nav) px+=nav.getBoundingClientRect().height;
    if(bar) px+=bar.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--chrome', Math.round(px)+'px');
  }
  chrome(); addEventListener('resize', chrome); addEventListener('load', chrome);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(chrome);
})();

/* ===== the hero object =====
   The outcome sits still at the centre. Everything we design keeps moving around it,
   and every piece feeds a pulse back into it. The one fixed point is the client's result. */
(function(){
  const svg=document.getElementById('horb'); if(!svg) return;
  const RMq=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CX=260, CY=260, CORE=64, RING=176;
  const octo=(cx,cy,r,rot=0)=>{let d='';for(let i=0;i<8;i++){const a=(-90+22.5+i*45)*Math.PI/180+rot;
    d+=(i?'L':'M')+(cx+r*Math.cos(a)).toFixed(2)+' '+(cy+r*Math.sin(a)).toFixed(2)+' ';}return d+'Z';};
  document.getElementById('orbCoreShape').setAttribute('d', octo(CX,CY,CORE));
  /* rings leaving the outcome, in the shape of the mark */
  document.getElementById('orbRipples').innerHTML =
    [0,1,2].map(()=>`<path class="orbrip" d="${octo(CX,CY,CORE)}" fill="none" stroke="#FF7F6B" stroke-width="2.5"/>`).join('');
  /* on a phone the ring labels are unreadable, so we drop them and crop in on the object */
  const mq=matchMedia('(max-width:1000px)');
  function fit(){ svg.setAttribute('viewBox', mq.matches ? '62 62 396 396' : '0 0 520 520'); }
  fit(); mq.addEventListener('change', fit);

  const PARTS=['the model','the agents','the rules','the evaluations','the memory','the human gate','the data','the record'];
  const geo=PARTS.map((p,i)=>{
    const a=(-90+i*45)*Math.PI/180;
    return {p, a, x:CX+RING*Math.cos(a), y:CY+RING*Math.sin(a), ux:Math.cos(a), uy:Math.sin(a)};
  });

  let links='', nodes='', pulses='';
  geo.forEach((g,i)=>{
    links+=`<line class="orbl" data-i="${i}" stroke="#DECDB8" stroke-width="1.5"/>`;
    pulses+=`<circle class="orbp" data-i="${i}" r="3.2" fill="#FF7F6B"/>`;
    const anchor = Math.abs(g.x-CX)<6 ? 'middle' : (g.x>CX ? 'start' : 'end');
    const lx = anchor==='start' ? g.x+18 : (anchor==='end' ? g.x-18 : g.x);
    const ly = g.y + (Math.abs(g.y-CY)<6 ? 5 : (g.y>CY ? 26 : -19));
    nodes+=`<g class="orbn" data-i="${i}">
      <path class="orbnp" d="" fill="#F2EAD9" stroke="#3D2A20" stroke-width="2"/>
      <text class="orbnt" x="${lx.toFixed(1)}" y="${ly.toFixed(1)}" font-size="12.5" font-weight="500" fill="#5F4234" text-anchor="${anchor}">${g.p}</text>
    </g>`;
  });
  document.getElementById('orbLinks').innerHTML=links;
  document.getElementById('orbPulses').innerHTML=pulses;
  document.getElementById('orbNodes').innerHTML=nodes;

  const lineEls=[...svg.querySelectorAll('.orbl')], pulseEls=[...svg.querySelectorAll('.orbp')],
        nodeEls=[...svg.querySelectorAll('.orbn')], nodePaths=[...svg.querySelectorAll('.orbnp')];

  function place(i, off){
    const g=geo[i];
    const x=g.x+g.ux*off, y=g.y+g.uy*off;
    nodePaths[i].setAttribute('d', octo(x, y, 11, off*0.05));
    const ix=CX+(CORE+7)*g.ux, iy=CY+(CORE+7)*g.uy;
    const ox=x-g.ux*13, oy=y-g.uy*13;
    lineEls[i].setAttribute('x1',ix.toFixed(1)); lineEls[i].setAttribute('y1',iy.toFixed(1));
    lineEls[i].setAttribute('x2',ox.toFixed(1)); lineEls[i].setAttribute('y2',oy.toFixed(1));
    return {ix,iy,ox,oy};
  }
  geo.forEach((g,i)=>place(i,0));

  if(RMq){ nodeEls.forEach(n=>n.style.opacity=1); lineEls.forEach(l=>l.style.opacity=1); return; }

  nodeEls.forEach((n,i)=>{ n.style.animationDelay=(0.95+i*0.08)+'s'; });
  lineEls.forEach((l,i)=>{ l.style.animationDelay=(1.0+i*0.08)+'s'; });

  /* one loop drives the float and the pulses. It idles when the hero is off screen. */
  let t=0, running=true, started=performance.now();
  const coreG=document.getElementById('orbCore');
  function frame(now){
    if(!running) return;
    t=(now-started)/1000;
    let hit=false;
    geo.forEach((g,i)=>{
      const off=Math.sin(t*0.7 + i*0.9)*3.2;              /* each piece breathes on its own phase */
      const {ix,iy,ox,oy}=place(i,off);
      const ph=((t*0.28 + i*0.125) % 1);                    /* a pulse runs from the piece into the outcome */
      const px=ox+(ix-ox)*ph, py=oy+(iy-oy)*ph;
      pulseEls[i].setAttribute('cx',px.toFixed(1)); pulseEls[i].setAttribute('cy',py.toFixed(1));
      const fade=Math.min(1, Math.min(ph,1-ph)*6);
      pulseEls[i].setAttribute('opacity', (fade*0.9).toFixed(2));
      if(ph>0.965) hit=true;   /* a pulse has just landed in the outcome */
    });
    coreG.classList.toggle('hit', hit);
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting && !running){ running=true; started=performance.now()-t*1000; requestAnimationFrame(frame); }
    else if(!e.isIntersecting){ running=false; }
  }),{threshold:0});
  io.observe(svg);

  /* the object answers the cursor, gently */
  const par=document.getElementById('orbPar'), hero=document.getElementById('hero');
  hero.addEventListener('pointermove', e=>{
    const r=hero.getBoundingClientRect();
    const dx=((e.clientX-r.left)/r.width-0.5), dy=((e.clientY-r.top)/r.height-0.5);
    par.style.transform=`translate(${(dx*16).toFixed(1)}px, ${(dy*14).toFixed(1)}px)`;
  });
  hero.addEventListener('pointerleave', ()=>{ par.style.transform='translate(0,0)'; });
})();


/* the stat counts up when the hero is seen. The number is the argument. */
(function(){
  const el=document.querySelector('.hnum'); if(!el) return;
  const RMq=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const target=95;
  if(RMq){ el.textContent=target+'%'; return; }
  let done=false;
  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(!e.isIntersecting || done) return;
    done=true;
    const t0=performance.now(), dur=1500;
    (function step(now){
      const p=Math.min(1,(now-t0)/dur);
      const e2=1-Math.pow(1-p,3);
      el.textContent=Math.round(target*e2)+'%';
      if(p<1) requestAnimationFrame(step);
    })(t0);
  }),{threshold:.6});
  io.observe(el);
})();




/* ===== act slides (3 and 4) =====
   The same machine as the chapter: hold the frame, move through the acts.
   One act on screen at a time, so nothing is given away early. */
(function(){
  const RMq=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const narrow=matchMedia('(max-width:760px)');
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));

  /* slide 3's stage: the method, drawn to fill the frame the way slide 2's field does */
  try{ (function(){
    const svg=document.getElementById('sstage3'); if(!svg) return;
    const octo=(cx,cy,r)=>{let d='';for(let i=0;i<8;i++){const a=(-90+22.5+i*45)*Math.PI/180;
      d+=(i?'L':'M')+(cx+r*Math.cos(a)).toFixed(1)+' '+(cy+r*Math.sin(a)).toFixed(1)+' ';}return d+'Z';};
    const LBL=['the outcome','the process','the method'];
    const SUB=['what must be true afterwards','designed, then tested on your work','the files your team runs'];
    const CX=132, R=74, ys=[92,260,428];
    let lines='', nodes='';
    for(let i=0;i<2;i++)
      lines+=`<line x1="${CX}" y1="${ys[i]+R+4}" x2="${CX}" y2="${ys[i+1]-R-4}" stroke="#DECDB8" stroke-width="2.5"/>`;
    ys.forEach((y,i)=>{
      nodes+=`<g class="mnode" data-i="${i}">
        <path class="mo" d="${octo(CX,y,R)}" fill="none" stroke="#DECDB8" stroke-width="2.5"/>
        <text class="mn" x="${CX}" y="${y+10}" font-size="21" font-weight="800" fill="#856B5A" text-anchor="middle" font-family="ui-monospace,'SF Mono',monospace">0${i+1}</text>
        <text class="ml" x="${CX+R+22}" y="${y-1}" font-size="15" font-weight="500" fill="#856B5A">${LBL[i]}</text>
        <text class="ms" x="${CX+R+22}" y="${y+18}" font-size="11" font-weight="500" fill="#856B5A">${SUB[i]}</text>
      </g>`;
    });
    document.getElementById('mline').innerHTML=lines;
    document.getElementById('mnodes').innerHTML=nodes;
    const sp=document.getElementById('mspine');
    const L=sp.getTotalLength?sp.getTotalLength():484;
    sp.setAttribute('stroke-dasharray', L); sp.setAttribute('stroke-dashoffset', L);
    sp.dataset.len=L;
  })(); }catch(e){}

  function wire(trackId, railId, stageSel, onAct, progId){
    const track=document.getElementById(trackId); if(!track) return;
    const prog=progId?document.getElementById(progId):null;
    const acts=[...track.querySelectorAll('.sact')];
    const rail=[...document.querySelectorAll('#'+railId+' i')];
    const stage=stageSel?[...track.querySelectorAll(stageSel)]:[];
    if(!acts.length) return;
    function showAll(){ acts.forEach(a=>a.classList.add('on')); stage.forEach(s=>s.classList.add('on')); rail.forEach(r=>r.classList.add('on')); if(prog) prog.style.width='100%'; if(onAct) onAct(acts.length-1, 1); }
    if(RMq || narrow.matches){ showAll(); }
    function render(p){
      const n=acts.length;
      const idx=Math.min(n-1, Math.floor(p*n));
      acts.forEach((a,i)=>a.classList.toggle('on', i===idx));
      stage.forEach((s,i)=>s.classList.toggle('on', i===idx));
      rail.forEach((r,i)=>r.classList.toggle('on', i<=idx));
      if(prog) prog.style.width=(p*100).toFixed(2)+'%';
      if(onAct) onAct(idx, p);
    }
    /* the drive: sample the frame's position every animation frame while the slide is near
       the viewport. No scroll events, so it holds in Safari, in embedded previews, and
       inside any container that scrolls on a wrapper rather than the window. */
    let live=false;
    function frame(){
      if(!live) return;
      if(narrow.matches){ showAll(); }
      else {
        const r=track.getBoundingClientRect();
        const span=r.height-innerHeight;
        if(span>40){ render(clamp((-r.top)/span)); }
        else { showAll(); }   /* the frame cannot pin here: give everything, hide nothing */
      }
      requestAnimationFrame(frame);
    }
    if(!RMq){
      const vio=new IntersectionObserver(es=>es.forEach(e=>{
        if(e.isIntersecting && !live){ live=true; requestAnimationFrame(frame); }
        else if(!e.isIntersecting){ live=false; }
      }),{rootMargin:'30%'});
      vio.observe(track);
      if(!narrow.matches) render(0);
    }
    const onNarrow=e=>{ if(e.matches) showAll(); };
    if(narrow.addEventListener){ narrow.addEventListener('change', onNarrow); }
    else if(narrow.addListener){ narrow.addListener(onNarrow); }
  }

  wire('strack3','srail3', null, (idx,p)=>{
    /* the spine draws continuously, so the scroll always answers */
    const sp=document.getElementById('mspine');
    if(sp){ const L=+sp.dataset.len; sp.setAttribute('stroke-dashoffset', L*(1-Math.min(1,p*1.06))); }
    document.querySelectorAll('#sstage3 .mnode').forEach((g,i)=>{
      const on=i===idx, done=i<idx;
      g.querySelector('.mo').setAttribute('stroke', on?'#FF7F6B':(done?'#856B5A':'#DECDB8'));
      g.querySelector('.mo').setAttribute('stroke-width', on?3:2.5);
      g.querySelector('.mo').setAttribute('fill', on?'#FF7F6B':'none');
      g.querySelector('.mn').setAttribute('fill', on?'#3D2A20':'#856B5A');
      g.querySelector('.ml').setAttribute('fill', on?'#3D2A20':(done?'#5F4234':'#856B5A'));
      g.querySelector('.ml').setAttribute('font-weight', on?800:500);
      g.querySelector('.ms').setAttribute('opacity', on?1:0);
      g.setAttribute('opacity', 1);
    });
  }, 'ssprog3');
  wire('strack4','srail4', '.excard', null, 'ssprog4');
  wire('mtrack1','mrail1', '.excard', null, 'mprog1');
  wire('mtrack2','mrail2', null, (idx,p)=>{ if(window.cycleSet) window.cycleSet(p); }, 'mprog2');
})();

/* ===== the pinned chapter: 100 pilots, 95 fade, 5 become the record =====
   Four acts, one viewport of scroll each, back to back. Every pixel of scroll
   moves something: there is no dead ground to get stuck in. */
(function(){
  const track=document.getElementById('ctrack'); if(!track) return;
  const field=document.getElementById('field'), rec=document.getElementById('crec'),
        rows=[...document.querySelectorAll('#crec .crow')],
        fieldLbl=document.getElementById('cfieldlbl'),
        acts=[...document.querySelectorAll('.cact')], rail=[...document.querySelectorAll('#crail i')];
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
  const seg=(p,s,e)=>clamp((p-s)/(e-s));
  const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;

  const COLS=10, GAP=52, R=15, X0=450-((COLS-1)*GAP)/2, Y0=150;
  const SURV=[13,27,46,62,81];
  const marks=[]; let html='';
  for(let i=0;i<100;i++){
    const cx=X0+(i%COLS)*GAP, cy=Y0+Math.floor(i/COLS)*GAP;
    let d='';
    for(let k=0;k<8;k++){const a=(-90+22.5+k*45)*Math.PI/180; d+=(k?'L':'M')+(cx+R*Math.cos(a)).toFixed(1)+' '+(cy+R*Math.sin(a)).toFixed(1)+' ';}
    const isS=SURV.includes(i);
    html+=`<path class="mk${isS?' surv':''}" d="${d}Z" fill="none" stroke="#856B5A" stroke-width="2.5" opacity="0"/>`;
    marks.push({cx,cy,isS});
  }
  field.innerHTML=html;
  const mk=[...field.querySelectorAll('.mk')];

  function render(p){
    const idx = p<0.25?0 : p<0.5?1 : p<0.75?2 : 3;
    acts.forEach((a,i)=>a.classList.toggle('on', i===idx));
    rail.forEach((r,i)=>r.classList.toggle('on', i<=idx));
    const a1=seg(p,0.00,0.25), a2=seg(p,0.25,0.50), a3=seg(p,0.50,0.75), a4=seg(p,0.75,1.00);

    mk.forEach((m,i)=>{
      const d=marks[i];
      const arrive=clamp((a1*118 - i)/14);
      let o=arrive, stroke='#856B5A', sw=2.5, tr='';
      if(d.isS){
        o=Math.max(arrive, a2>0?1:arrive);
        stroke = a2>0.12 ? '#FF7F6B' : '#856B5A';
        sw = a2>0.12 ? 3.5 : 2.5;
        if(a3>0){
          const e=ease(a3), ti=SURV.indexOf(i);
          tr=`translate(${((450-d.cx)*e).toFixed(1)},${(((Y0+126)+ti*54-d.cy)*e).toFixed(1)})`;
        }
        if(a4>0) o=1-ease(seg(p,0.75,0.84));
      } else {
        const fade=ease(a2);
        o=arrive*(1-fade*0.95);
        tr=`translate(0,${(fade*16).toFixed(1)})`;
        if(a3>0) o=arrive*(1-ease(a3))*0.05;
      }
      m.setAttribute('opacity', o.toFixed(3));
      m.setAttribute('stroke', stroke);
      m.setAttribute('stroke-width', sw);
      m.setAttribute('transform', tr);
    });

    if(fieldLbl) fieldLbl.style.opacity=(1-ease(seg(p,0.5,0.62))).toFixed(3);
    rec.style.opacity=ease(seg(p,0.78,0.86)).toFixed(3);
    rows.forEach((row,i)=>{
      const t=ease(seg(p, 0.80+i*0.028, 0.88+i*0.028));
      row.style.opacity=t.toFixed(3);
      row.style.transform=`translateX(${(-14*(1-t)).toFixed(1)}px)`;
    });
  }

  /* the drive: frame sampling, the same mechanism as slides 3 and 4 */
  let live=false;
  function frame(){
    if(!live) return;
    const r=track.getBoundingClientRect();
    const span=r.height-innerHeight;
    if(span>40) render(clamp((-r.top)/span));
    requestAnimationFrame(frame);
  }
  if(RM){ render(1); }
  else {
    const vio=new IntersectionObserver(es=>es.forEach(e=>{
      if(e.isIntersecting && !live){ live=true; requestAnimationFrame(frame); }
      else if(!e.isIntersecting){ live=false; }
    }),{rootMargin:'30%'});
    vio.observe(track);
    render(0);
  }
})();

// hero card cursor tilt
const tw=document.querySelector('.tiltwrap');
if(tw && !RM && matchMedia('(pointer:fine)').matches){
  tw.addEventListener('mousemove',e=>{
    const r=tw.getBoundingClientRect();
    const x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
    tw.style.transform=`perspective(900px) rotateY(${(x*8).toFixed(2)}deg) rotateX(${(-y*8).toFixed(2)}deg)`;
  });
  tw.addEventListener('mouseleave',()=>{tw.style.transform='perspective(900px)';});
}
/* ---------- the product page's depth chooser ----------
   Picking a depth picks the variant, fills the nest and swaps the panel. The radio
   is the source of truth, so the form still posts correctly with JS switched off. */
(function(){
  const form=document.querySelector('.buyform.depthblock'); if(!form) return;
  const picks=[...form.querySelectorAll('.depthpick input[data-depth]')];
  const btns=[...form.querySelectorAll('.depthpick .dbtn')];
  const panels=[...form.querySelectorAll('.dpanel')];
  const layers=[...form.querySelectorAll('.dnest .dlayer')];
  if(!picks.length) return;
  function set(d){
    btns.forEach(b=>b.classList.toggle('active', b.dataset.d===String(d)));
    panels.forEach(p=>p.classList.toggle('active', p.dataset.d===String(d)));
    layers.forEach(l=>l.classList.toggle('on', +l.dataset.d <= +d));
  }
  picks.forEach(i=>i.addEventListener('change', ()=>{ if(i.checked) set(i.dataset.depth); }));
  const on=picks.find(i=>i.checked)||picks[0];
  set(on.dataset.depth);
})();
